<template>
    <div>
        <div class="flex justify-between items-center mb-10 mt-3">
            <div class="">
                <h1 class="text-2xl md:text-3xl text-gray-800 font-bold">
                    My Points
                </h1>
            </div>

            <div
                class="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2"
            >
                <a
                    href="#"
                    @click.prevent="setShowAffiliateModal(true)"
                    class="text-orange text-xs hover:text-orange-400 self-center mr-4"
                >
                    Affiliate Disclosure
                </a>
                <a
                    href="#"
                    @click.prevent="setProgramModal(true)"
                    class="btn btn-gray !mt-0"
                    role="button"
                >
                    <svg
                        class="w-3 h-3 md:w-4 md:h-4 flex-shrink-0"
                        viewBox="0 0 16 16"
                        fill="#F27249"
                    >
                        <path
                            d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z"
                        />
                    </svg>
                    <span class="text-xs md:text-base ml-2">Add Program</span>
                </a>
            </div>
        </div>

        <UserRewards
            v-for="(user, i) in rewards.users"
            :user="user"
            :key="'user-' + i"
            @editProgram="editProgram"
            @deleteProgram="deleteProgram"
        />

<!--
        TODO: MY1-836 add hide/show banner feature from backend
        <award-booking-program-card></award-booking-program-card>
-->

        <AddReward />

        <ProgramOptionsModal />

        <div class="loading-wallet text-white" v-if="loading">
            <i class="far fa-spinner-third fa-spin text-2xl"></i>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { usePointsStore } from "@/store/points";
import { useAppStore } from "@/store/app";

import vClickOutside from "click-outside-vue3";
import UserRewards from "@/components/mypoints/user-rewards.vue";
import AddReward from "@/components/mypoints/modals/add-reward.vue";
import ProgramOptionsModal from "@/components/mypoints/modals/program-options.vue";
import AwardBookingProgramCard from "@/components/mypoints/award-booking-program-card.vue";

export default {
    components: {
        UserRewards,
        AddReward,
        ProgramOptionsModal,
        AwardBookingProgramCard,
    },
    directives: {
        ClickOutside: vClickOutside.directive,
    },
    props: {},
    data: () => ({
        errors: [],
    }),
    watch: {},
    computed: {
        ...mapState(usePointsStore, [
            "loading",
            "rewards",
            "programs",
            "reward",
            "user",
            "addRewardUser",
            "showProgramModal",
            "showEditProgramModal",
        ]),
    },
    methods: {
        ...mapActions(usePointsStore, [
            "getRewards",
            "deleteProgram",
            "editProgram",
            "setProgramModal",
            "setEditProgramModal",
            "showProgramModalAction",
        ]),
        ...mapActions(useAppStore, ["setShowAffiliateModal"]),
    },
    created() {},
    mounted() {
        this.getRewards();
    },
};
</script>
<style lang="scss" scoped>
.fadeInOut-enter-active,
.fadeInOut-leave-active {
    transition: opacity 0.8s;
    opacity: 1;
}
.fadeInOut-enter,
.fadeInOut-leave-to {
    opacity: 0;
}
</style>
